var _defs, _g, _rect, _rect2, _rect3, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMyProjects(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .my-projects-cls-2 {\n        fill: transparent;\n      }\n\n      .my-projects-cls-3 {\n        fill: currentColor;\n      }\n\n      .my-projects-cls-4 {\n        fill: currentColor;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "my-projects-cls-2",
    d: "M24.357,25H.643A.643.643,0,0,1,0,24.357V.644A.643.643,0,0,1,.643,0H24.357A.643.643,0,0,1,25,.644V24.357A.643.643,0,0,1,24.357,25Z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "my-projects-cls-3",
    x: 5.523,
    y: 16.884,
    width: 13.955,
    height: 2.594
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "my-projects-cls-3",
    x: 5.523,
    y: 11.203,
    width: 15.67,
    height: 2.594
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "my-projects-cls-3",
    x: 5.523,
    y: 5.523,
    width: 19.477,
    height: 2.594
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "my-projects-cls-4",
    d: "M23.714,11.2V23.714H1.287V1.286H23.714v1.15H25V.643A.643.643,0,0,0,24.357,0H.644A.643.643,0,0,0,0,.643V24.357A.643.643,0,0,0,.644,25H24.357A.643.643,0,0,0,25,24.357V11.2Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyProjects);
export default __webpack_public_path__ + "static/media/my-projects.46afb53c.svg";
export { ForwardRef as ReactComponent };